import request, { URL } from "./request";

const offlineEndpoints = {
  databases: "offline/bundle/databases",
  generate: "offline/bundle/generate",
  generateAll: "offline/bundle/generate-all",
  stats: "offline/bundle/stats",
  download: "offline/download",
};

/**
 * Service pour la gestion des bases de données offline
 */
const offlineService = {
  /**
   * Récupère la liste de toutes les bases offline disponibles
   * @returns {Promise} Liste des bases offline
   */
  getAll: () => {
    return request.get(offlineEndpoints.databases);
  },

  /**
   * Génère une nouvelle base offline pour une classe
   * @param {number} classeId - ID de la classe
   * @param {string} version - Version optionnelle de la base
   * @returns {Promise} Résultat de la génération
   */
  generate: (classeId, version = null) => {
    const data = { classe_id: classeId };
    if (version) {
      data.version = version;
    }
    return request.post(offlineEndpoints.generate, data);
  },

  /**
   * Génère les bases offline pour toutes les classes
   * @param {string} version - Version optionnelle
   * @returns {Promise} Résultat de la génération
   */
  generateAll: (version = null) => {
    const data = {};
    if (version) {
      data.version = version;
    }
    return request.post(offlineEndpoints.generateAll, data);
  },

  /**
   * Supprime une base offline
   * @param {string} filename - Nom du fichier à supprimer
   * @returns {Promise} Résultat de la suppression
   */
  delete: (filename) => {
    return request.delete(`${offlineEndpoints.databases}/${filename}`);
  },

  /**
   * Récupère les statistiques des bases offline
   * @returns {Promise} Statistiques
   */
  getStats: () => {
    return request.get(offlineEndpoints.stats);
  },

  /**
   * Obtient l'URL de téléchargement d'une base offline
   * @param {string} filename - Nom du fichier
   * @returns {string} URL de téléchargement
   */
  getDownloadUrl: (filename) => {
    return `${URL}/api/${offlineEndpoints.download}/${filename}`;
  },
};

export default offlineService;
